// Fog
// Features:
// - Simple scene-wide fog effect

import { useEffect } from 'react'
import { useThree } from '@react-three/fiber'
import * as THREE from 'three'

export default function Fog({ fogRadius }) {
    const scene = useThree((state) => state.scene)

    useEffect(() => {
        scene.fog = new THREE.Fog(new THREE.Color(0x000000), 1, fogRadius)
    }, [scene, fogRadius])

    return null
}
